import css from 'styled-jsx/css';
import breakPoints from 'helpers/Styles';

export default css`
  .container {
    max-width: 1440px;
    padding: 40px 48px;
    margin: 0 auto;
  }
  .section {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5%;
  }
  .video-section {
    width: 50%;
    position: relative;
    cursor: pointer;
    height: 350px;
  }
  .description-section {
    width: 50%;
  }
  .title {
    font-family: "big_noodle_titling";
    font-size: 32px;
  }
  .description {
    font-family: 'Roboto-Light';
    font-size: 16px;
  }
  .circle-background {
    background-color: #242424;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .circled-play-white {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .modal-btn-close {
    position: absolute;
    right: 20px;
    background-color: #950810;
    border: 1px solid #950810;
    padding: 5px;
    border-radius: 3px;
    color: white;
  }
  .ultralabs-video-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: black;
    height: 90%;
    margin-top: 15px;
  }
  .modal-header {
    margin: 0;
    font-family: 'big_noodle_titling';
    font-size: 24px;
    width: 85%;
  }
  .ultralabs-video-dekstop {
    display: flex;
  }
  .ultralabs-video-mobile {
    display: none;
  }
  @media (max-width: ${breakPoints.small}) {
    .container {
      padding: 0px 15px;
    }
    .section {
      flex-direction: column !important;
      width: 100%;
      margin-top: 0;
    }
    .video-section {
      width: 100%;
      margin-right: 0 !important;
      margin-left: 0 !important;
      margin-top: 15px;
      height: 300px;
    }
    .title {
      text-align: center;
      font-size: 25px;
      margin-top: 10px;
    }
    .description-section {
      width: 85%;
    }
    .description {
      font-size: 14px;
      text-align: center;
    }
    .circle-background {
      height: 25px;
      width: 25px;
    }
    .circled-play-white {
      height: 55px;
      width: 55px;
    }
    .ultralabs-video-container {
      height: 90%;
      overflow: none;
    }
    .modal-header {
      font-size: 17px;
      width: 90%;
    }
    .modal-btn-close {
      border-radius: 25px;
      width: 25px;
      height: 25px;
      top: 3%;
      right: 2%;
      font-size: 11px;
      text-transform: lowercase;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }
    .ultralabs-video-dekstop {
      display: none;
    }
    .ultralabs-video-mobile {
      display: flex;
      justify-content: start;
      align-items: center;
      padding: 10px;
      background-color: #141414;
      margin-bottom: 20px;
      border: 2px solid #232323;
      flex-direction: column;
    }
  }
`;

export const global = css.global`
  @media (max-width: 1024px) {
    .sticky-wrapper {
      width: 100%;
      z-index: 2;
    }
  }
  .ReactModal__Overlay {
    z-index: 9;
  }
`;